var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 7c0-1.66 1.34-3 3-3h14c1.65 0 3 1.34 3 3v9c0 1.65-1.35 3-3 3H5c-1.66 0-3-1.35-3-3V7Zm3-1c-.56 0-1 .44-1 1v9c0 .55.44 1 1 1h14c.55 0 1-.45 1-1V7c0-.56-.45-1-1-1H5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10.33H3v-2h18v1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 13c-.28 0-.5.22-.5.5 0 .27.22.5.5.5 .27 0 .5-.23.5-.5 0-.28-.23-.5-.5-.5Zm-2.5.5C4.5 12.11 5.61 11 7 11c1.38 0 2.5 1.11 2.5 2.5C9.5 14.88 8.38 16 7 16c-1.39 0-2.5-1.12-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13c-.28 0-.5.22-.5.5 0 .27.22.5.5.5 .27 0 .5-.23.5-.5 0-.28-.23-.5-.5-.5Zm-2.5.5c0-1.39 1.11-2.5 2.5-2.5 1.38 0 2.5 1.11 2.5 2.5 0 1.38-1.12 2.5-2.5 2.5 -1.39 0-2.5-1.12-2.5-2.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcard);
export default __webpack_public_path__ + "static/media/credit card.2b2a345bf7ce19ebb942d54ba30ba2de.svg";
export { ForwardRef as ReactComponent };